module.exports = __webpack_public_path__ + "f7f5de543dbebc158c337488ce04715c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/savanna.png
// module id = 2735
// module chunks = 0